import { Component, inject, Input } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivityInterface } from '@vendasta/crm';
import { CrmActivityAssociationPopoverComponent } from '../../../../activities/association-popover.component';
import { ActivityAssociationService } from '../../../../activities/activity-association.service';
import { AVATAR_WIDTH } from '../../../../../../constants';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { GalaxyFilterInterface, GalaxyFilterOperator } from '@vendasta/galaxy/filter/chips';
import { SystemFieldIds } from '../../../../../../shared-services';
import { encodeFilters } from '@vendasta/galaxy/filter/chips/src/utils';
import { Clipboard } from '@angular/cdk/clipboard';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { CrmActivityTemplateOptionsDirective } from '../../../../activities/activity-template-options.directive';

interface ActivityCardProps {
  effectiveDate?: Date;
}

@Component({
  selector: 'crm-activity-card',
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    GalaxyAvatarModule,
    CrmActivityAssociationPopoverComponent,
    TranslateModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    CrmActivityTemplateOptionsDirective,
  ],
  providers: [ActivityAssociationService],
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
  animations: [
    trigger('bodyExpansion', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ActivityCardComponent {
  @Input() activity?: ActivityInterface & ActivityCardProps;
  @Input() showTitle = true;
  @Input() showExpandButton = true;
  @Input() icon = '';
  @Input() showAssociationPopover = true;

  private readonly document = inject(DOCUMENT);
  private readonly clipboard = inject(Clipboard);
  private readonly snackbarService = inject(SnackbarService);
  protected readonly AVATAR_WIDTH = AVATAR_WIDTH;
  protected readonly dateFormat = DateFormat.mediumDateShortTime;

  state = 'collapsed';

  private constructCopyLink(): string {
    const documentUrl = this.document.URL.split('?')[0];

    const glxyFilter: GalaxyFilterInterface = {
      fieldId: SystemFieldIds.ActivityID,
      operator: GalaxyFilterOperator.FILTER_OPERATOR_IS,
      values: [
        {
          string: this.activity?.crmObjectId,
        },
      ],
    };
    const encodedFilter = encodeFilters([glxyFilter]);
    return `${documentUrl}?filter=${encodedFilter}`;
  }

  toggle() {
    this.state = this.state === 'expanded' ? 'collapsed' : 'expanded';
  }
  copyLinkToActivity(): void {
    this.clipboard.copy(this.constructCopyLink());
    this.snackbarService.openSuccessSnack('COMMON.SNACKBAR_MESSAGE.COPY_SUCCESS');
  }
}
